import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@components/ui/sheet";
import CustomWidget from "@components/common/Widget";
import DonutChart from "@components/common/charts/DonutChart";
import DataTable from "@components/common/DataTable";
// import TableLoader from "@components/loaders/TableLoader";
// import {
//   getFilesByDomain,
//   getSensitiveFiles,
//   getFilesByExtention,
// } from "@services/api/sensitiveData";
import { Loader2 } from "lucide-react";
import { EpochToDateTime, formatBandwidth } from "@utils/utils";
import FileInvestigator from "@components/common/ddr/FileInvestigator";
import {
  dataSubClassification,
  getDomainTypeSummary,
  getGenericList,
} from "@services/api/ddrCommonApis";
// import {
//   Dialog,
//   DialogContent,
//   DialogHeader,
//   DialogTitle,
// } from "@components/ui/dialog";
import CustomTooltip from "@components/common/CustomTooltip";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@components/ui/tabs";
import SiloImage from "@components/common/ddr/SiloImage";
import { getEmailList, getFileList } from "@services/api/datainventory";
import {
  getConversionList,
  getDatabaseTableList,
} from "@services/api/ddrCommonApis";
import TableLoader from "@components/loaders/TableLoader";
import NoData from "@components/common/NoDataLabel";

interface CategoryDataDialog {
  open: boolean;
  onClose: (e: boolean) => void;
  selectedDomain: string;
  classification: string;
  service?: string;
  siloName?: string;
  isSensitiveData?: boolean;
  user?: string;
  isExternal?: number;
}

const CategoryDataDialog: React.FC<CategoryDataDialog> = ({
  open,
  onClose,
  selectedDomain,
  classification,
  service,
  siloName,
  isSensitiveData = false,
  user,
  isExternal,
}) => {
  const [fileId, setFileId] = React.useState(0);
  // const [sensitiveData, setSensitiveData] = React.useState<any>([]);
  // const [categoryOpen, setCategoryOpen] = React.useState(false);
  // const [serviceList, setServiceList] = React.useState<any>([]);
  const [_serviceList, _setServiceList] = React.useState<any>([]);
  // const [filesPage, setFilesPage] = React.useState(0);
  // const [sensitiveFilesPage, setSensitiveFilesPage] = React.useState(0);

  // const {
  //   data: categoryFiles,
  //   isLoading: categoryFilesLoading,
  //   refetch: categoryFilesRefetch,
  // } = useQuery(
  //   ["sensitiveFiles", selectedDomain],
  //   ({ signal }) => getFilesByDomain(selectedDomain, 10, filesPage, signal),
  //   {
  //     enabled: classification === "category",
  //   },
  // );

  // const {
  //   data: sensitiveFiles,
  //   isLoading: sensitiveFilesLoading,
  //   refetch: refetchSensitiveFiles,
  // } = useQuery(
  //   ["getSensitiveFiles", selectedDomain],
  //   ({ signal }) =>
  //     getSensitiveFiles(
  //       selectedDomain,
  //       signal,
  //       10,
  //       sensitiveFilesPage,
  //       service,
  //       siloName,
  //     ),
  //   {
  //     // enabled: classification === "sensitivity",
  //     enabled: false,
  //   },
  // );

  // const { data: extenstionFiles } = useQuery(
  //   ["extenstionFiles", selectedDomain],
  //   ({ signal }) => getFilesByExtention(selectedDomain, signal),
  //   {
  //     enabled: classification === "file_type",
  //   },
  // );

  // const { data: sensitiveSubclassData, isLoading } = useQuery<{
  //   req_type: string;
  //   classification: string;
  //   siloName?: string;
  //   service?: string;
  //   user_name?: string;
  //   is_external?: number;
  // }>(
  //   ["sensitiveSubclassData", selectedDomain],
  //   () =>
  //     dataSubClassification({
  //       req_type:
  //         classification == "file_type" ? classification : selectedDomain,
  //       classification:
  //         classification == "file_type" ? selectedDomain : classification,
  //       service: service,
  //       silo_name: siloName,
  //       user_name: user,
  //       is_external: isExternal,
  //     }),
  //   {
  //     enabled:
  //       (classification == "sensitivity" || classification == "file_type") &&
  //       selectedDomain != "",
  //   },
  // );

  // let domain_based_data: any = null;
  // // let totalFileCount: number = 0;
  // if (sensitiveSubclassData) {
  //   domain_based_data = [];
  //   Object.entries(sensitiveSubclassData).forEach(([key, value]) => {
  //     let temp:{ label: string; value: number }[] = [];
  //     Object.entries(value).forEach(([key1, value1]) => {
  //       temp.push({ label: key1, value: parseInt(value1 as string) });
  //     });
  //     domain_based_data[key] = temp;
  //   });
  //   console.log("domain_based_data", domain_based_data);
  //   // totalFileCount = Object.values(sensitiveSubclassData).reduce(
  //   //   (acc, val) => acc + parseInt(val),
  //   //   0,
  //   // );
  // }

  // React.useEffect(() => {
  //   categoryFilesRefetch();
  // }, [filesPage]);

  // React.useEffect(() => {
  //   if (classification === "sensitivity") {
  //     refetchSensitiveFiles();
  //   }
  // }, [sensitiveFilesPage, classification]);

  // React.useEffect(() => {
  //   if (categoryFiles) {
  //     const temp: any = [];
  //     temp["files"] = categoryFiles.overview.total_file_count;
  //     temp["size"] = categoryFiles.overview.total_file_size;
  //     temp["users"] = categoryFiles.overview.total_users_count;

  //     const tempFiles: any = [];
  //     categoryFiles.files_list.forEach((file: any) => {
  //       tempFiles.push({
  //         fileId: file.file_id,
  //         filename: (
  //           <CustomTooltip text={file.file_name} className="p-2">
  //             <span>
  //               {file.file_name.length > 30
  //                 ? file.file_name.slice(0, 30) + "..."
  //                 : file.file_name}
  //             </span>
  //           </CustomTooltip>
  //         ),
  //         category: file.classification,
  //         filetype: file.type,
  //         size: formatBandwidth(file.size),
  //         modified_time: "- - -",
  //         access_time: "- - -",
  //         source: "- - -",
  //         sensitivity: "- - -",
  //       });
  //     });
  //     temp["files_list"] = tempFiles;

  //     setSensitiveData(temp);

  //     const service_List = categoryFiles.files_list.reduce(
  //       (acc: { label: string; value: number }[], item: any) => {
  //         const label = item.service_name;
  //         const found = acc.find((service) => service.label === label);
  //         if (found) {
  //           found.value += 1;
  //         } else {
  //           acc.push({ label, value: 1 });
  //         }
  //         return acc;
  //       },
  //       [],
  //     );
  //     setServiceList(service_List);
  //   }
  // }, [categoryFiles]);

  // React.useEffect(() => {
  //   if (sensitiveFiles) {
  //     const temp: any = [];
  //     const tempFiles: any = [];
  //     temp["files"] = sensitiveFiles?.total_count;
  //     temp["size"] = 0;
  //     temp["users"] = 0;

  //     sensitiveFiles?.data?.forEach((file: any) => {
  //       tempFiles.push({
  //         fileId: file.file_id,
  //         filename: (
  //           <CustomTooltip text={file.file_name} className="p-2">
  //             <span>
  //               {file.file_name.length > 30
  //                 ? file.file_name.slice(0, 30) + "..."
  //                 : file.file_name}
  //             </span>
  //           </CustomTooltip>
  //         ),
  //         category: file.classification,
  //         filetype: file.type,
  //         size: formatBandwidth(file.size),
  //         modified_time: "- - -",
  //         access_time: "- - -",
  //         source: "- - -",
  //         sensitivity: "- - -",
  //       });
  //       temp["size"] += file.size;
  //     });

  //     temp["files_list"] = tempFiles;

  //     setSensitiveData(temp);

  //     const service_List = sensitiveFiles?.data.reduce(
  //       (acc: { label: string; value: number }[], item: any) => {
  //         const label = item.service_name;
  //         const found = acc.find((service) => service.label === label);
  //         if (found) {
  //           found.value += 1;
  //         } else {
  //           acc.push({ label, value: 1 });
  //         }
  //         return acc;
  //       },
  //       [],
  //     );
  //     setServiceList(service_List);
  //   }
  // }, [sensitiveFiles]);

  // React.useEffect(() => {
  //   if (extenstionFiles) {
  //     const temp: any = [];
  //     const tempFiles: any = [];
  //     temp["files"] = extenstionFiles.length;
  //     temp["size"] = 0;
  //     temp["users"] = 0;

  //     extenstionFiles.forEach((file: any) => {
  //       tempFiles.push({
  //         fileId: file.file_id,
  //         filename: (
  //           <CustomTooltip text={file.file_name} className="p-2">
  //             <span>
  //               {file.file_name.length > 30
  //                 ? file.file_name.slice(0, 30) + "..."
  //                 : file.file_name}
  //             </span>
  //           </CustomTooltip>
  //         ),
  //         category: file.classification,
  //         filetype: file.type,
  //         size: formatBandwidth(file.size),
  //         modified_time: "- - -",
  //         access_time: "- - -",
  //         source: file.service_name,
  //         sensitivity: "- - -",
  //       });
  //       temp["size"] += file.size;
  //     });

  //     temp["files_list"] = tempFiles;

  //     setSensitiveData(temp);

  //     const service_List = extenstionFiles.reduce(
  //       (acc: { label: string; value: number }[], item: any) => {
  //         const label = item.service_name;
  //         const found = acc.find((service) => service.label === label);
  //         if (found) {
  //           found.value += 1;
  //         } else {
  //           acc.push({ label, value: 1 });
  //         }
  //         return acc;
  //       },
  //       [],
  //     );
  //     setServiceList(service_List);
  //   }
  // }, [extenstionFiles]);

  // const FilesDetailColums = [
  //   { header: "Filename", accessor: "filename", type: "component" },
  //   { header: "Category", accessor: "category" },
  //   { header: "Filetype", accessor: "filetype" },
  //   { header: "Size", accessor: "size" },
  //   { header: "Modified Time", accessor: "modified_time" },
  //   { header: "Access Time", accessor: "access_time" },
  //   { header: "Source", accessor: "source" },
  //   { header: "Sensitivity", accessor: "sensitivity" },
  // ];

  // const category_based_popup = () => {
  //   setCategoryOpen(true);
  // };

  let _dataToSend: {
    is_sensitive: string;
    sensitivity?: string;
    classification?: string;
    service?: string;
    silo_name?: string;
    user_name?: string;
    is_external?: number;
    file_extension?: string;
  } = {
    is_sensitive: isSensitiveData ? "True" : "False",
    service: service,
    silo_name: siloName,
    user_name: user,
    is_external: isExternal,
    file_extension: selectedDomain,
  };
  if (classification == "sensitivity") {
    _dataToSend = { ..._dataToSend, sensitivity: selectedDomain };
  } else if (classification == "category") {
    _dataToSend = { ..._dataToSend, classification: selectedDomain };
  }
  const {
    data: domainTypeSummary,
    isLoading: domainsummaryLoading,
    isFetching: isDomainSummaryFetching,
  } = useQuery(
    ["getDomainTypeSummary", selectedDomain],
    () => getDomainTypeSummary(_dataToSend),
    {
      enabled: selectedDomain != "",
    },
  );

  React.useEffect(() => {
    if (domainTypeSummary) {
      const temp: { label: string; value: number }[] = [];
      Object.keys(domainTypeSummary).forEach((key) => {
        if (
          key === "fileService" ||
          key === "emailService" ||
          key === "dbService" ||
          key === "conversationService" ||
          key == "genericService"
        ) {
          Object.entries(domainTypeSummary[key]).forEach(([key1, value1]) => {
            temp.push({ label: key1, value: value1 as number });
          });
        }
      });
      _setServiceList(temp);
    }
  }, [domainTypeSummary]);

  return (
    <>
      {fileId != 0 && (
        <FileInvestigator
          Id={fileId}
          isOpen={true}
          onClose={() => setFileId(0)}
        />
      )}
      <Sheet open={open} onOpenChange={() => onClose(false)}>
        <SheetContent className="sm:max-w-[50vw] overflow-y-auto">
          <SheetHeader>
            <SheetTitle>{selectedDomain}</SheetTitle>
          </SheetHeader>
          <div className="w-full relative">
            <div className="grid grid-cols-12 gap-2">
              <div className="col-span-6">
                <CustomWidget
                  title="Overview"
                  info={`${selectedDomain} sensitive data files overview.`}
                  className="h-80 relative"
                >
                  {domainsummaryLoading || isDomainSummaryFetching ? (
                    <Loader2 className="w-6 h-6 animate-spin" />
                  ) : (
                    domainTypeSummary && (
                      <div className="grid gap-2 grid-cols-2">
                        {/* file */}
                        {domainTypeSummary.fileService &&
                          Object.keys(domainTypeSummary.fileService).length >
                            0 && (
                            <div className="rounded border-solid border-2 border-slate-300 mt-2">
                              <div className="mb-1 ps-2 border-r">
                                <span className="text-xl font-bold">
                                  {domainTypeSummary.fileCount}
                                </span>
                                <span className="ps-2 text-xs text-primary">
                                  Total Files
                                </span>
                              </div>
                              <div className="mb-1 ps-2 border-r">
                                <span className="text-xl font-bold">
                                  {formatBandwidth(
                                    domainTypeSummary.filesize ?? 0,
                                    "B",
                                    1,
                                  )}
                                </span>
                                <span className="ps-2 text-xs text-primary">
                                  Total Size
                                </span>
                              </div>
                            </div>
                          )}
                        {/* email */}
                        {domainTypeSummary.emailService &&
                          Object.keys(domainTypeSummary.emailService).length >
                            0 && (
                            <div className="rounded border-solid border-2 border-slate-300 mt-2">
                              <div className="mb-1 ps-2 border-r">
                                <span className="text-xl font-bold">
                                  {domainTypeSummary.emailCount}
                                </span>
                                <span className="ps-2 text-xs text-primary">
                                  Total Sensitive Emails
                                </span>
                              </div>
                              <div className="mb-1 ps-2 border-r">
                                <span className="text-xl font-bold">
                                  {domainTypeSummary.attachmentCount}
                                </span>
                                <span className="ps-2 text-xs text-primary">
                                  Total Attachments
                                </span>
                              </div>
                            </div>
                          )}
                        {/* database */}
                        {domainTypeSummary.dbService &&
                          Object.keys(domainTypeSummary.dbService).length >
                            0 && (
                            <div className="rounded border-solid border-2 border-slate-300 mt-2">
                              <div className="mb-1 ps-2 border-r">
                                <span className="text-xl font-bold">
                                  {domainTypeSummary.dbCount}
                                </span>
                                <span className="ps-2 text-xs text-primary">
                                  Total Database
                                </span>
                              </div>
                              <div className="mb-1 ps-2 border-r">
                                <span className="text-xl font-bold">
                                  {domainTypeSummary.tableCount ?? 0}
                                </span>
                                <span className="ps-2 text-xs text-primary">
                                  Total Tables
                                </span>
                              </div>
                              {/* <div className="mb-1 ps-2 border-r">
                                <span className="text-xl font-bold">
                                  {formatBandwidth(
                                    domainTypeSummary.dbsize ?? 0,
                                    "B",
                                    1,
                                  )}
                                </span>
                                <span className="ps-2 text-xs text-primary">
                                  Total Database Size
                                </span>
                              </div> */}
                            </div>
                          )}
                        {/* conversations */}
                        {domainTypeSummary.conversationService &&
                          Object.keys(domainTypeSummary.conversationService)
                            .length > 0 && (
                            <div className="rounded border-solid border-2 border-slate-300 mt-2">
                              <div className="mb-1 ps-2 border-r">
                                <span className="text-xl font-bold">
                                  {domainTypeSummary.conversationCount}
                                </span>
                                <span className="ps-2 text-xs text-primary">
                                  Total Sensitive Conversations
                                </span>
                              </div>
                              <div className="mb-1 ps-2 border-r">
                                <span className="text-xl font-bold">
                                  {
                                    domainTypeSummary.conversationattachmentCount
                                  }
                                </span>
                                <span className="ps-2 text-xs text-primary">
                                  Total Attachments
                                </span>
                              </div>
                            </div>
                          )}
                        {domainTypeSummary.genericService &&
                          Object.keys(domainTypeSummary.genericService).length >
                            0 && (
                            <div className="rounded border-solid border-2 border-slate-300 mt-2">
                              <div className="mb-1 ps-2 border-r">
                                <span className="text-xl font-bold">
                                  {domainTypeSummary.genericCount}
                                </span>
                                <span className="ps-2 text-xs text-primary">
                                  Total Generic
                                </span>
                              </div>
                              <div className="mb-1 ps-2 border-r">
                                <span className="text-xl font-bold">
                                  {domainTypeSummary.genericattachmentCount}
                                </span>
                                <span className="ps-2 text-xs text-primary">
                                  Total Attachments
                                </span>
                              </div>
                            </div>
                          )}
                      </div>
                    )
                  )}
                </CustomWidget>
              </div>
              <div className="col-span-6">
                <CustomWidget
                  title="Services"
                  info={`Total number of ${selectedDomain} data in each services (excuding attachments).`}
                  className="h-80"
                >
                  <div id="datasizechart" className="h-[20vh] w-full">
                    <DonutChart
                      // data={serviceList}
                      data={_serviceList}
                      parentid="datasizechart"
                      valuetype="count"
                      groupSmall={false}
                    />
                  </div>
                </CustomWidget>
              </div>
              {/*------------------------ subclassification--------------- */}
              {/* {sensitiveSubclassData && (
                <div className="col-span-12">
                  <CustomWidget
                    title="Category Based Count"
                    info={`Total number of sensitive data files in each domain.`}
                    className="h-full"
                  >
                    <div className="grid grid-cols-6 gap-2 pt-2 my-4 max-h-[40vh] overflow-y-auto">
                      {isLoading ? (
                        <>Loading...!</>
                      ) : (
                        domain_based_data.map((item, index) => (
                          <div
                            key={index}
                            // onClick={() => {
                            //   category_based_popup();
                            // }}
                            // className="cursor-pointer bg-blue-500 text-white rounded-full h-32 w-32 flex flex-col items-center justify-center"
                            className="bg-blue-500 text-white rounded-full h-32 w-32 flex flex-col items-center justify-center"
                          >
                            <CustomTooltip text={item.label}>
                              <span className="text-sm">
                                {item.label.length > 10
                                  ? item.label.slice(0, 10) + "..."
                                  : item.label}
                              </span>
                            </CustomTooltip>
                            <span className="text-lg font-bold">
                              {item.value}
                            </span>
                          </div>
                        ))
                      )}
                    </div>
                  </CustomWidget>
                </div>
              )} */}
              {/*------------------------ subclassification--------------- */}
              {/* <div className="col-span-12">
                <CustomWidget
                  title="Files"
                  info={`Details of ${selectedDomain} sensitive data files.`}
                >
                  {categoryFilesLoading || sensitiveFilesLoading ? (
                    <TableLoader />
                  ) : (
                    <DataTable
                      loading={categoryFilesLoading || sensitiveFilesLoading}
                      cols={FilesDetailColums}
                      data={sensitiveData.files_list ?? []}
                      onRowClick={(e: string) => setFileId(parseInt(e))}
                      rowClickColumn="fileId"
                      totalCount={sensitiveData.files} // total count of files
                      countPerPageSelection={true}
                      filterFunction={(e: any) => {
                        if (classification === "sensitivity") {
                          setSensitiveFilesPage(e.pageIndex);
                        } else if (classification === "category") {
                          setFilesPage(e.pageIndex);
                        }
                      }}
                    />
                  )}
                </CustomWidget>
              </div> */}
            </div>
            {sourceListData(
              domainTypeSummary,
              selectedDomain,
              classification,
              isSensitiveData,
              service,
              siloName,
              user,
              isExternal,
            )}
          </div>
        </SheetContent>
      </Sheet>

      {/* <Dialog
        open={categoryOpen}
        onOpenChange={() => {
          setCategoryOpen(false);
        }}
      >
        <DialogContent className="max-w-[50vw]">
          <DialogHeader>
            <DialogTitle>Data</DialogTitle>
          </DialogHeader>
          <div className="w-full relative">
            //<DataTable cols={filesDetailColums} data={filesDetailRows} /> 
          </div>
        </DialogContent>
      </Dialog> */}
    </>
  );
};

export default CategoryDataDialog;

const sourceListData = (
  domainTypeSummary: any,
  selectedDomain: string,
  classification: string,
  isSensitiveData: boolean,
  service: string = "",
  siloName: string = "",
  user?: string,
  isExternal?: number,
): JSX.Element => {
  const [sourceItemId, setSourceItemId] = useState(null);
  const [detailsType, setDetailsType] = useState<
    "file" | "email" | "database" | "conversation" | "generic"
  >("file");
  const [selectedTab, setSelectedTab] = useState<
    "file" | "email" | "database" | "conversation" | "generic"
  >("file");
  const [fileData, setFileData] = useState<any[]>([]);
  const [emailsData, setEmailsData] = useState<any[]>([]);
  const [databaseData, setDatabaseData] = useState<any[]>([]);
  const [conversationData, setConversationData] = useState<any[]>([]);
  const [genericData, setGenericData] = useState<any[]>([]);
  const [fileCursor, setFileCursor] = React.useState<string>("");

  const [fileListParams, setFileListParams] = React.useState({
    limit: 10,
    page: 0,
    search_text: "",
    sort_key: "",
    sort_order: "",
    search_columns: ["file_name", "size", "service_name"],
    next_cursor: "",
    prev_cursor: "",
  });
  const [emailListPage, setEmailListPage] = React.useState({
    limit: 10,
    page: 0,
    sort_key: "",
    sort_order: "",
    search_text: "",
    search_columns: ["email_sender", "email_subject", "server_name", "sent_at"],
  });
  const [dbListPage, setDbListPage] = React.useState({
    limit: 10,
    page: 0,
    search_text: "",
    sort_key: "",
    sort_order: "",
    search_columns: ["table", "database", "source"],
  });
  const [conversationListPage, setConversationListPage] = React.useState({
    page_size: 10,
    page: 0,
    search_text: "",
    sort_key: "",
    sort_order: "",
    search_columns: [
      "conversation_sender",
      "recipients",
      "server_name",
      "sent_at",
    ],
  });
  const [genericListPage, setGenericListPage] = React.useState({
    limit: 10,
    page: 0,
    search_text: "",
    sort_key: "",
    sort_order: "",
    search_columns: ["user_name", "server_name", "sent_at"],
  });

  const filesCols = [
    { header: "Filename", accessor: "file_name" },
    { header: "Size", accessor: "size" },
    { header: "Source", accessor: "service_name", type: "component" },
  ];

  const emailCols = [
    { header: "Email", accessor: "email_sender" },
    { header: "Subject", accessor: "email_subject" },
    { header: "Source", accessor: "server_name", type: "component" },
    { header: "Sent At", accessor: "sent_at" },
  ];

  const databaseCols = [
    { header: "Tables", accessor: "table" },
    { header: "Database", accessor: "database" },
    { header: "Source", accessor: "source", type: "component" },
  ];

  const conversationCols = [
    { header: "Sender", accessor: "conversation_sender" },
    { header: "Receiver", accessor: "recipients" },
    { header: "Source", accessor: "server_name", type: "component" },
    { header: "Sent At", accessor: "sent_at" },
  ];

  const genericCols = [
    { header: "User Name", accessor: "user_name" },
    { header: "Source", accessor: "server_name", type: "component" },
    { header: "Sent At", accessor: "sent_at" },
  ];

  const {
    data: sensitiveSubclassData,
    isLoading,
    isFetching,
  } = useQuery<{
    req_type: string;
    classification: string;
    siloName?: string;
    service?: string;
    user_name?: string;
    is_external?: number;
  }>(
    ["sensitiveSubclassData", selectedDomain],
    () =>
      dataSubClassification({
        req_type:
          classification == "file_type" ? classification : selectedDomain,
        classification:
          classification == "file_type" ? selectedDomain : classification,
        service: service,
        silo_name: siloName,
        user_name: user,
        is_external: isExternal,
      }),
    {
      enabled:
        (classification == "sensitivity" || classification == "file_type") &&
        selectedDomain != "",
    },
  );

  // let domain_based_data: any = null;
  // // let totalFileCount: number = 0;
  // if (sensitiveSubclassData) {
  //   domain_based_data = [];
  //   Object.entries(sensitiveSubclassData).forEach(([key, value]) => {
  //     let temp:{ label: string; value: number }[] = [];
  //     Object.entries(value).forEach(([key1, value1]) => {
  //       temp.push({ label: key1, value: parseInt(value1 as string) });
  //     });
  //     domain_based_data[key] = temp;
  //   });
  //   console.log("domain_based_data", domain_based_data);
  //   // totalFileCount = Object.values(sensitiveSubclassData).reduce(
  //   //   (acc, val) => acc + parseInt(val),
  //   //   0,
  //   // );
  // }

  //---file----
  let dataTosend: {
    source: string;
    silo_name: string;
    limit: number;
    page: number;
    sensitivity?: string;
    domain?: string;
    is_sensitive?: string;
    search_text?: string;
    sort_key?: string;
    sort_order?: string;
    search_columns?: string[];
    user_name?: string;
    extension?: string;
    is_external?: number;
    cursor: string;
  } = {
    source: service,
    silo_name: siloName,
    user_name: user,
    is_sensitive: isSensitiveData ? "True" : "False",
    limit: fileListParams.limit,
    page: fileListParams.page,
    search_text: fileListParams.search_text,
    sort_key: fileListParams.sort_key,
    sort_order: fileListParams.sort_order,
    search_columns: fileListParams.search_columns,
    is_external: isExternal,
    cursor: fileCursor || "",
  };
  if (classification === "sensitivity") {
    dataTosend = { ...dataTosend, sensitivity: selectedDomain };
  } else if (classification === "category") {
    dataTosend = { ...dataTosend, domain: selectedDomain };
  } else if (classification === "file_type") {
    dataTosend = { ...dataTosend, extension: selectedDomain };
  }
  const {
    isLoading: fileListLoading,
    data: fileList,
    refetch: refetchFileList,
    isRefetching: isFileListRefetching,
    isFetching: isFileFetching,
  } = useQuery(["getFiles"], () => getFileList(dataTosend), {
    enabled: selectedTab === "file",
  });

  useEffect(() => {
    if (selectedTab === "file") refetchFileList();
  }, [fileListParams, selectedTab]);

  useEffect(() => {
    if (fileList) {
      const temp: any = [];
      fileList?.data.forEach((element: any) => {
        temp.push({
          file_name: element.file_name,
          file_id: element.file_id,
          size: formatBandwidth(element.size, "B", 2),
          service_name: (
            <SiloImage type={element.service_name} variant={"icon"} />
          ),
        });
      });
      setFileData(temp);
    }
  }, [fileList]);

  const fileTableFilter = (e: any) => {
    const isSameFilter =
      fileListParams.search_text === e.searchText &&
      fileListParams.sort_key === e.sortKey &&
      fileListParams.sort_order === e.sortOrder;

    const isSamePage =
      fileListParams.limit === e.pageSize &&
      fileListParams.page === e.pageIndex;

    if (isSameFilter && isSamePage) {
      return;
    }

    const pageSizeChanged = fileListParams.limit !== e.pageSize;
    const isNextPage = e.pageIndex > fileListParams.page;

    const nextCursor =
      !pageSizeChanged && isSameFilter ? fileList?.next_cursor || "" : "";

    const prevCursor =
      !pageSizeChanged && isSameFilter ? fileList?.prev_cursor || "" : "";

    setFileCursor(isNextPage ? nextCursor : prevCursor);

    fileListParams.limit = e.pageSize;
    fileListParams.page = e.pageIndex;
    fileListParams.search_text = e.searchText;
    fileListParams.sort_key = e.sortKey;
    fileListParams.sort_order = e.sortOrder;
    fileListParams.next_cursor = nextCursor;
    fileListParams.prev_cursor = prevCursor;
    setFileListParams({ ...fileListParams });
  };

  //--email--
  let dataTosendEmail: {
    source: string;
    limit: number;
    page: number;
    sensitivity?: string;
    domain?: string;
    is_sensitive?: string;
    search_text?: string;
    sort_key?: string;
    sort_order?: string;
    search_columns?: string[];
    email_address?: string;
    is_external?: number;
    extension?: string;
  } = {
    source: service,
    limit: emailListPage.limit,
    page: emailListPage.page,
    email_address: user,
    is_sensitive: isSensitiveData ? "True" : "False",
    search_text: emailListPage.search_text,
    sort_key: emailListPage.sort_key,
    sort_order: emailListPage.sort_order,
    search_columns: emailListPage.search_columns,
    is_external: isExternal,
  };
  if (classification === "sensitivity") {
    dataTosendEmail = { ...dataTosendEmail, sensitivity: selectedDomain };
  } else if (classification === "category") {
    dataTosendEmail = { ...dataTosendEmail, domain: selectedDomain };
  } else if (classification === "file_type") {
    dataTosendEmail = { ...dataTosendEmail, extension: selectedDomain };
  }
  const {
    isLoading: emailDataLoading,
    data: emailList,
    refetch: refetchEmailList,
    isRefetching: isEmailListRefetching,
    isFetching: isEmailFetching,
  } = useQuery(["getEmailList"], () => getEmailList(dataTosendEmail), {
    enabled: selectedTab === "email",
  });

  useEffect(() => {
    if (selectedTab === "email") refetchEmailList();
    console.log("refetchEmailList", selectedTab, emailListPage);
  }, [emailListPage, selectedTab]);

  useEffect(() => {
    if (emailList) {
      let temp: any = [];
      temp = emailList?.data?.map((element: any) => {
        return {
          email_id: element.email_id,
          email_sender: element.email_sender,
          email_subject: element.email_subject,
          server_name: (
            <SiloImage type={element.server_name} variant={"icon"} />
          ),
          sent_at: element.sent_at ? EpochToDateTime(element.sent_at) : "-",
        };
      });
      setEmailsData(temp);
    }
  }, [emailList]);

  //---database---
  let dataTosendDb: {
    source: string;
    db_name: string;
    limit: number;
    page: number;
    sensitivity?: string;
    domain?: string;
    is_sensitive?: string;
    search_text?: string;
    sort_key?: string;
    sort_order?: string;
    search_columns?: string[];
    user_name?: string;
    extension?: string;
  } = {
    source: service,
    db_name: "",
    limit: dbListPage.limit,
    page: dbListPage.page,
    user_name: user,
    is_sensitive: isSensitiveData ? "True" : "False",
    search_text: dbListPage.search_text,
    sort_key: dbListPage.sort_key,
    sort_order: dbListPage.sort_order,
    search_columns: dbListPage.search_columns,
  };
  if (classification === "sensitivity") {
    dataTosendDb = { ...dataTosendDb, sensitivity: selectedDomain };
  } else if (classification === "category") {
    dataTosendDb = { ...dataTosendDb, domain: selectedDomain };
  } else if (classification === "file_type") {
    dataTosendDb = { ...dataTosendDb, extension: selectedDomain };
  }
  const {
    isLoading: dbTableLoading,
    data: dbTableData,
    refetch: refetchDbTable,
    isRefetching: isDbTableRefetching,
    isFetching: isDbFetching,
  } = useQuery(
    ["getDatabaseTableList"],
    ({ signal }: any) => getDatabaseTableList(dataTosendDb, signal),
    { enabled: selectedTab === "database" },
  );

  useEffect(() => {
    if (selectedTab === "database") refetchDbTable();
  }, [dbListPage, selectedTab]);

  useEffect(() => {
    if (dbTableData) {
      let temp: any = [];
      temp = dbTableData?.data?.map((element: any) => {
        return {
          table_id: element.table_id,
          table: element.table,
          database: element.database,
          source: <SiloImage type={element.source} variant={"icon"} />,
        };
      });
      setDatabaseData(temp);
    }
  }, [dbTableData]);

  const renderSubCategory = (type: string) => {
    if (sensitiveSubclassData) {
      const temp = (sensitiveSubclassData as Record<string, any>)[type] || {};
      const tempData: { label: string; value: number }[] = [];
      Object.entries(temp).forEach(([key, value]) => {
        tempData.push({ label: key, value: parseInt(value as string) });
      });
      return (
        <div className="grid grid-cols-6 gap-2 pt-2 my-4">
          {tempData && tempData.length > 0 ? (
            tempData.map((item: any, index: number) => (
              <div
                key={index}
                // onClick={() => {
                //   category_based_popup();
                // }}
                // className="cursor-pointer bg-blue-500 text-white rounded-full h-32 w-32 flex flex-col items-center justify-center"
                className="bg-blue-500 text-white rounded-full h-32 w-32 flex flex-col items-center justify-center"
              >
                <CustomTooltip text={item.label}>
                  <span className="text-sm">
                    {item.label.length > 10
                      ? item.label.slice(0, 10) + "..."
                      : item.label}
                  </span>
                </CustomTooltip>
                <span className="text-lg font-bold">{item.value}</span>
              </div>
            ))
          ) : (
            <div className="col-span-12 text-center">
              <NoData />
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div className="absolute top-2/4 left-2/4 -translate-x-2/4 -translate-y-2/4">
          <NoData />
        </div>
      );
    }
  };

  //---conversation---
  let dataTosendConversation: {
    source: string;
    limit: number;
    page: number;
    sensitivity?: string;
    domain?: string;
    is_sensitive?: string;
    search_text?: string;
    sort_key?: string;
    sort_order?: string;
    search_columns?: string[];
    email_address?: string;
    is_external?: number;
    extension?: string;
  } = {
    source: service,
    limit: conversationListPage.page_size,
    page: conversationListPage.page,
    email_address: user,
    is_sensitive: isSensitiveData ? "True" : "False",
    search_text: conversationListPage.search_text,
    sort_key: conversationListPage.sort_key,
    sort_order: conversationListPage.sort_order,
    search_columns: conversationListPage.search_columns,
    is_external: isExternal,
  };
  if (classification === "sensitivity") {
    dataTosendConversation = {
      ...dataTosendConversation,
      sensitivity: selectedDomain,
    };
  } else if (classification === "category") {
    dataTosendConversation = {
      ...dataTosendConversation,
      domain: selectedDomain,
    };
  } else if (classification === "file_type") {
    dataTosendConversation = {
      ...dataTosendConversation,
      extension: selectedDomain,
    };
  }
  const {
    isLoading: conversationListLoading,
    data: conversationList,
    refetch: refetchConversationList,
    isRefetching: isConversationListRefetching,
    isFetching: isConversationFetching,
  } = useQuery(
    ["getConversations"],
    () => getConversionList(dataTosendConversation),
    { enabled: selectedTab === "conversation" },
  );

  useEffect(() => {
    if (selectedTab === "conversation") refetchConversationList();
  }, [conversationListPage, selectedTab]);

  useEffect(() => {
    if (conversationList) {
      let temp: any = [];
      temp = conversationList?.data?.map((element: any) => {
        return {
          conversation_id: element.conversation_id,
          server_name: element.server_name,
          conversation_sender: element.conversation_sender,
          recipients: element.recipients,
          service_name: (
            <SiloImage type={element.service_name} variant={"icon"} />
          ),
          sent_at: element.sent_at ? EpochToDateTime(element.sent_at) : "-",
        };
      });
      setConversationData(temp);
    }
  }, [conversationList]);

  // ---generic-----------
  let dataTosendGeneric: {
    source: string;
    limit: number;
    page: number;
    sensitivity?: string;
    domain?: string;
    is_sensitive?: string;
    search_text?: string;
    sort_key?: string;
    sort_order?: string;
    search_columns?: string[];
    user_name?: string;
    extension?: string;
  } = {
    source: service,
    limit: 10,
    page: 0,
    user_name: user,
    is_sensitive: isSensitiveData ? "True" : "False",
  };
  if (classification === "sensitivity") {
    dataTosendGeneric = { ...dataTosendGeneric, sensitivity: selectedDomain };
  } else if (classification === "category") {
    dataTosendGeneric = { ...dataTosendGeneric, domain: selectedDomain };
  } else if (classification === "file_type") {
    dataTosendGeneric = { ...dataTosendGeneric, extension: selectedDomain };
  }
  const {
    isLoading: genericListLoading,
    data: genericList,
    refetch: refetchGenericList,
    isRefetching: isGenericListRefetching,
    isFetching: isGenericFetching,
  } = useQuery(["getGenericList"], () => getGenericList(dataTosendGeneric), {
    enabled: selectedTab === "generic",
  });

  useEffect(() => {
    if (selectedTab === "generic") refetchGenericList();
  }, [selectedTab]);

  useEffect(() => {
    if (genericList) {
      let temp: any = [];
      temp = genericList?.data?.map((element: any) => {
        return {
          generic_id: element.generic_id,
          user_name: element.user_name,
          server_name: (
            <SiloImage type={element.server_name} variant={"icon"} />
          ),
          sent_at: element.sent_at ? EpochToDateTime(element.sent_at) : "-",
        };
      });
      setGenericData(temp);
    }
  }, [genericList]);

  const getEmailFilterFunction = (e: any) => {
    if (
      emailListPage.limit == e.pageSize &&
      emailListPage.page == e.pageIndex &&
      emailListPage.search_text == e.searchText &&
      emailListPage.sort_key == e.sortKey &&
      emailListPage.sort_order == e.sortOrder
    ) {
      return;
    } else {
      emailListPage.limit = e.pageSize;
      emailListPage.page = e.pageIndex;
      emailListPage.search_text = e.searchText;
      emailListPage.sort_key = e.sortKey;
      emailListPage.sort_order = e.sortOrder;
      setEmailListPage({ ...emailListPage });
    }
  };

  const getDatabaseFilterFunction = (e: any) => {
    if (
      dbListPage.limit == e.pageSize &&
      dbListPage.page == e.pageIndex &&
      dbListPage.search_text == e.searchText &&
      dbListPage.sort_key == e.sortKey &&
      dbListPage.sort_order == e.sortOrder
    ) {
      return;
    } else {
      dbListPage.limit = e.pageSize;
      dbListPage.page = e.pageIndex;
      dbListPage.search_text = e.searchText;
      dbListPage.sort_key = e.sortKey;
      dbListPage.sort_order = e.sortOrder;
      setDbListPage({ ...dbListPage });
    }
  };

  const getConversationFilterFunction = (e: any) => {
    if (
      conversationListPage.page_size == e.pageSize &&
      conversationListPage.page == e.pageIndex &&
      conversationListPage.search_text == e.searchText &&
      conversationListPage.sort_key == e.sortKey &&
      conversationListPage.sort_order == e.sortOrder
    ) {
      return;
    } else {
      conversationListPage.page_size = e.pageSize;
      conversationListPage.page = e.pageIndex;
      conversationListPage.search_text = e.searchText;
      conversationListPage.sort_key = e.sortKey;
      conversationListPage.sort_order = e.sortOrder;
      setConversationListPage({ ...conversationListPage });
    }
  };

  const getGenericFilterFunction = (e: any) => {
    if (
      genericListPage.limit == e.pageSize &&
      genericListPage.page == e.pageIndex &&
      genericListPage.search_text == e.searchText &&
      genericListPage.sort_key == e.sortKey &&
      genericListPage.sort_order == e.sortOrder
    ) {
      return;
    } else {
      genericListPage.limit = e.pageSize;
      genericListPage.page = e.pageIndex;
      genericListPage.search_text = e.searchText;
      genericListPage.sort_key = e.sortKey;
      genericListPage.sort_order = e.sortOrder;
      setGenericListPage({ ...genericListPage });
    }
  };

  return (
    <>
      {sourceItemId && (
        <FileInvestigator
          Id={sourceItemId}
          isOpen={true}
          onClose={() => setSourceItemId(null)}
          type={detailsType}
        />
      )}
      <Tabs defaultValue="files" className="w-full mt-2">
        <TabsList className="inline-block">
          <TabsTrigger
            value="files"
            onClick={() => {
              setSelectedTab("file");
            }}
          >
            <span className="pe-2">Files</span>
            <span className="font-bold">
              {/* : {isFileFetching ? 0 : fileList?.total_files_count || 0} */}:{" "}
              {domainTypeSummary?.fileCount || 0}
            </span>
          </TabsTrigger>
          <TabsTrigger
            value="emails"
            onClick={() => {
              setSelectedTab("email");
            }}
          >
            <span className="pe-2">Emails</span>
            <span className="font-bold">
              {/* : {isEmailFetching ? 0 : emailList?.total_emails_count || 0} */}
              : {domainTypeSummary?.emailCount || 0}
            </span>
          </TabsTrigger>
          <TabsTrigger
            value="database"
            onClick={() => {
              setSelectedTab("database");
            }}
          >
            <span className="pe-2">Database</span>
            <span className="font-bold">
              {/* : {isDbFetching ? 0 : dbTableData?.total_db_count || 0} */}:{" "}
              {domainTypeSummary?.dbCount || 0}
            </span>
          </TabsTrigger>
          <TabsTrigger
            value="conversations"
            onClick={() => {
              setSelectedTab("conversation");
            }}
          >
            <span className="pe-2">Conversations</span>
            <span className="font-bold">
              {/* : {isConversationFetching ? 0 : conversationList?.total_conversation_count || 0} */}
              : {domainTypeSummary?.conversationCount || 0}
            </span>
          </TabsTrigger>
          <TabsTrigger
            value="generic"
            onClick={() => {
              setSelectedTab("generic");
            }}
          >
            <span className="pe-2">Generic</span>
            <span className="font-bold">
              : {domainTypeSummary?.genericCount || 0}
            </span>
          </TabsTrigger>
        </TabsList>
        <TabsContent value="files">
          <>
            {(classification == "sensitivity" ||
              classification == "file_type") &&
              selectedDomain != "" &&
              (isLoading || isFetching ? (
                <TableLoader />
              ) : (
                <CustomWidget
                  title="Category Based Count"
                  info={`Total number of sensitive data in each domain.`}
                  className="min-h-60 h-full mb-2 relative"
                >
                  <>{renderSubCategory("files")}</>
                </CustomWidget>
              ))}
            <CustomWidget info="Files">
              <DataTable
                loading={
                  fileListLoading || isFileListRefetching || isFileFetching
                }
                data={fileData}
                // sort={true}
                apiSearch={true}
                countPerPageSelection={true}
                colFilter={false}
                cols={filesCols}
                onRowClick={(val) => {
                  setSourceItemId(val);
                  setDetailsType("file");
                }}
                rowClickColumn="file_id"
                totalCount={fileList?.total_files_count || 0}
                filterFunction={(e: any) => fileTableFilter(e)}
                nextPreviousCursor={{
                  next: fileList?.next_cursor || "",
                  previous: fileList?.prev_cursor || "",
                }}
              />
            </CustomWidget>
          </>
        </TabsContent>
        <TabsContent value="emails">
          <>
            {(classification == "sensitivity" ||
              classification == "file_type") &&
              selectedDomain != "" &&
              (isLoading || isFetching ? (
                <TableLoader />
              ) : (
                <CustomWidget
                  title="Category Based Count"
                  info={`Total number of sensitive data in each domain.`}
                  className="min-h-60 h-full mb-2 relative"
                >
                  <>{renderSubCategory("emails")}</>
                </CustomWidget>
              ))}
            <CustomWidget info="Emails">
              <DataTable
                loading={
                  emailDataLoading || isEmailListRefetching || isEmailFetching
                }
                data={emailsData}
                sort={true}
                apiSearch={true}
                colFilter={false}
                cols={emailCols}
                onRowClick={(val) => {
                  setSourceItemId(val);
                  setDetailsType("email");
                }}
                rowClickColumn="email_id"
                totalCount={emailList?.total_emails_count || 0}
                filterFunction={(e: any) => getEmailFilterFunction(e)}
                countPerPageSelection={true}
              />
            </CustomWidget>
          </>
        </TabsContent>
        <TabsContent value="database">
          <>
            {(classification == "sensitivity" ||
              classification == "file_type") &&
              selectedDomain != "" &&
              (isLoading || isFetching ? (
                <TableLoader />
              ) : (
                <CustomWidget
                  title="Category Based Count"
                  info={`Total number of sensitive data in each domain.`}
                  className="min-h-60 h-full mb-2 relative"
                >
                  <>{renderSubCategory("databases")}</>
                </CustomWidget>
              ))}
            <CustomWidget info="Database">
              <DataTable
                loading={dbTableLoading || isDbTableRefetching || isDbFetching}
                data={databaseData}
                sort={true}
                apiSearch={true}
                countPerPageSelection={true}
                colFilter={false}
                cols={databaseCols}
                onRowClick={(val) => {
                  setSourceItemId(val);
                  setDetailsType("database");
                }}
                rowClickColumn="table_id"
                totalCount={dbTableData?.total_db_count || 0}
                filterFunction={(e: any) => getDatabaseFilterFunction(e)}
              />
            </CustomWidget>
          </>
        </TabsContent>
        <TabsContent value="conversations">
          <>
            {(classification == "sensitivity" ||
              classification == "file_type") &&
              selectedDomain != "" &&
              (isLoading || isFetching ? (
                <TableLoader />
              ) : (
                <CustomWidget
                  title="Category Based Count"
                  info={`Total number of sensitive data in each domain.`}
                  className="min-h-60 h-full mb-2 relative"
                >
                  <>{renderSubCategory("conversations")}</>
                </CustomWidget>
              ))}
            <CustomWidget info="Conversations">
              <DataTable
                loading={
                  conversationListLoading ||
                  isConversationListRefetching ||
                  isConversationFetching
                }
                data={conversationData}
                sort={true}
                colFilter={false}
                cols={conversationCols}
                onRowClick={(val) => {
                  setSourceItemId(val);
                  setDetailsType("conversation");
                }}
                rowClickColumn="conversation_id"
                totalCount={conversationList?.total_conversation_count || 0}
                filterFunction={(e: any) => getConversationFilterFunction(e)}
                apiSearch={true}
              />
            </CustomWidget>
          </>
        </TabsContent>
        <TabsContent value="generic">
          <>
            {(classification == "sensitivity" ||
              classification == "file_type") &&
              selectedDomain != "" &&
              (isLoading || isFetching ? (
                <TableLoader />
              ) : (
                <CustomWidget
                  title="Category Based Count"
                  info={`Total number of sensitive data in each domain.`}
                  className="min-h-60 h-full mb-2 relative"
                >
                  <>{renderSubCategory("generics")}</>
                </CustomWidget>
              ))}
            <CustomWidget info="Generic">
              <DataTable
                loading={
                  genericListLoading ||
                  isGenericListRefetching ||
                  isGenericFetching
                }
                data={genericData}
                sort={true}
                colFilter={false}
                cols={genericCols}
                onRowClick={(val) => {
                  setSourceItemId(val);
                  setDetailsType("generic");
                }}
                rowClickColumn="generic_id"
                totalCount={genericList?.total_generic_count || 0}
                filterFunction={(e: any) => getGenericFilterFunction(e)}
                apiSearch={true}
              />
            </CustomWidget>
          </>
        </TabsContent>
      </Tabs>
    </>
  );
};
